import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { useQueryTable } from "../../misc/components/queryTable/Hooks/UseQueryTable";
import { OverreadStatusIdEnum, QueryCondition, QueryOrderDirection } from "../../misc/api/apiTypes";
import DlcoAnalysisSetList from "./AnalysisSetsList/DlcoAnalysisSetList";
import DlcoSessionListScreen from "./DlcoSessionListScreen";
import { DlcoAnalysisScreen } from "./DlcoAnalysisScreen";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { PrivateRoute } from "../../Core/PrivateRoute";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";

export const DlcoRoot = () => {
    const { tableParameters } = useCurrentStudyConfigurationContext();
    
    const analysisSetQueryTableReducer = useQueryTable({
        query: {
            Order: {
                Member: "CreatedDateTime",
                Direction: QueryOrderDirection.Ascending,
            },
            Page: {
                Current: 1,
                Length: tableParameters.DefaultPageSize,
            },
            Filters: [{
                Member: 'StatusId',
                Condition: QueryCondition.Equal,
                Values: [OverreadStatusIdEnum.Pending, OverreadStatusIdEnum.NotStarted]
            }]
        }
    });

    return (
        <Switch>
            <PrivateRoute path="/Dlco" exact permissions={[PermissionEnum.AccessSingleDlcoSession, PermissionEnum.AccessAllDlcoSessions, PermissionEnum.OverreadDlcoSession]}>
                <DlcoSessionListScreen />
            </PrivateRoute>
            <PrivateRoute path="/Dlco/Analysis" exact permissions={[PermissionEnum.OverreadDlcoSession]}>
                <DlcoAnalysisSetList queryTableReducer={analysisSetQueryTableReducer} />
            </PrivateRoute>
            <PrivateRoute path="/Dlco/Analysis/:analysisSetId/:viewState" permissions={[PermissionEnum.OverreadDlcoSession, PermissionEnum.AccessSingleDlcoSession]}>
                <DlcoAnalysisScreen />
            </PrivateRoute>
        </Switch>
    );
}
